import { isInsideEditorPreviewFrame } from '@Core/lib/pageEditorPreview';

let authoringRuntime: Promise<unknown> | null = null;

/**
 * Loads `pageRuntime/rowRuntime.ts`, which seeds the registry components that
 * authoring source renders in its first frame. A published row-based page
 * does not load it: it loads only the Page SDK members its source names.
 */
export function loadAuthoringRuntime(): Promise<unknown> {
  authoringRuntime ??= import('@Pages/pageRuntime/rowRuntime');

  return authoringRuntime;
}

/**
 * A draft preview, and a published page framed by the editor, render source
 * that changes as someone types, so they wait for the authoring runtime.
 */
export function rendersAuthoringSource({
  isAuthoringPreview,
  isDraftPreview
}: {
  isAuthoringPreview?: boolean;
  isDraftPreview?: boolean;
}): boolean {
  return isAuthoringPreview === true || isDraftPreview === true || isInsideEditorPreviewFrame();
}
